import { Auth as Cognito } from '@aws-amplify/auth'

const ENV = {
  dev: {
    url: 'staging-auth.birdlevel.com',
    userPoolId: 'us-east-2_7y5tbEEqg',
    clientId: '7skba8f5h3uckbl7tqrg34qcof',
  },

  prod: {
    url: 'auth.birdlevel.com',
    userPoolId: 'us-east-2_EFjQWys5X',
    clientId: '1p8jldh4bftaftb6l2bci57828',
  },
}

const cognitoInfo = process.env.NODE_ENV === 'production' ? ENV.prod : ENV.dev

Cognito.configure({
  userPoolId: cognitoInfo.userPoolId,
  userPoolWebClientId: cognitoInfo.clientId,
  region: 'us-east-2',
  oauth: {
    domain: cognitoInfo.url,
    scope: ['email', 'profile', 'openid'],
    redirectSignIn: `${window.location.origin}/auth/callback`,
    redirectSignOut: `${window.location.origin}/auth/logout`,
    responseType: 'code',
  },
})

export { Cognito }
